<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :label="$t('userManagementStoreAccessAdd')"
    :no-data-text="$t('noDataText')"
    :loading="loading"
    :menu-props="menuProps"
    :filter="customSearchFilter"
    hide-selected
    clearable
    open-on-clear
    item-text="itemText"
    item-value="itemValue"
    data-cy="create-storeaccess-widget"
    @change="onStoreAccessSelected"
  >
    <template
      slot="item"
      slot-scope="data"
    >
      <v-list-tile-avatar tile>
        <v-icon color="msr">
          location_on
        </v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content
        :title="
          data.item.store.zipcode +
            ' ' +
            data.item.store.city +
            ', ' +
            data.item.store.address
        "
      >
        <v-list-tile-sub-title>
          <small class="grey--text text--darken-2">{{
            data.item.store.name
          }}</small>
        </v-list-tile-sub-title>
        <v-list-tile-title>
          <span class="body-2">{{ data.item.store.city }}</span>
          <span
            v-if="data.item.store.location"
            class="body-2 grey--text"
          >{{
            data.item.store.location
          }}</span>
        </v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import matchesFilter from '@/matchesFilter';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
      menuProps: {
        contentClass:
          'menu-list-item-dividers cy-create-storeaccess-widget-menu-content',
      },
    };
  },
  methods: {
    /**
     * Search in StoreAccess inner Store fields.
     *
     * Also handles umlaut ambiguity ('oe' vs 'ö' etc.).
     *
     * https://stackoverflow.com/a/46101073
     */
    customSearchFilter: (item, queryText, itemText) => {
      queryText = queryText.toString().toLowerCase();
      return (
        matchesFilter(item.store.city, queryText) ||
        matchesFilter(item.store.name, queryText) ||
        matchesFilter(item.store.address, queryText) ||
        matchesFilter(item.store.zipcode, queryText) ||
        matchesFilter(item.store.location, queryText)
      );
    },
    clear() {
      this.selected = null;
    },
    onStoreAccessSelected(storeaccess) {
      this.$nextTick(() => {
        this.clear();
      });
      // Can be empty when pressing the clear button.
      if (!storeaccess) {
        return;
      }
      this.$emit('selected', storeaccess);
    },
  },
};
</script>

<style>
.menu-list-item-dividers.v-autocomplete__content
  .v-list
  > div[role='listitem']:not(:last-child)
  .v-list__tile {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
</style>



// WEBPACK FOOTER //
// src/components/UserManagement/CreateStoreAccessWidget.vue